import React, { useState, useMemo, useRef, useEffect } from 'react';
import { Protected } from "@/components/layout/Protected";
import { Box, Stepper, InputAdornment, IconButton, Step, StepLabel, Button, CircularProgress, Grid, CssBaseline, Container, Modal, StepIconProps, Typography, Tooltip, FormControl, Autocomplete, FormLabel, RadioGroup, FormControlLabel, Radio, Checkbox } from '@mui/material'
import { Props } from "./GcProvider.type"
import { styled } from '@mui/material/styles';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import InfoIcon from '@mui/icons-material/Info';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { FormGeneralInformation } from "./FormGeneralInformation";
import BusinessIcon from '@mui/icons-material/Business';
import { FormMainDirection } from "./FormInventario";
import BadgeIcon from '@mui/icons-material/Badge';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import EditIcon from '@mui/icons-material/Edit';
import { AddCircle, Assignment } from "@mui/icons-material";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import TextField from '@mui/material/TextField';
import { Input } from '@components/common/Input';
import { InputRef } from '@components/common/Input/InputInterfaces';
import "./GcProvider.css";
import EditLocationAltIcon from '@mui/icons-material/EditLocationAlt';
import { FormInformation } from './FormInformation';
import { DataModalAccount } from './ModalAccount/DataModalContacto';
import { DataModalEnterprise } from './ModalEnterprise/DataModalEnterprise';

const steps = [{ name: 'Información General', icon: null },
{ name: 'Dirección Principal', icon: null },
{ name: 'Información Comercial', icon: null }
]

interface Column {
   id: 'rut' | 'razonSocial' | 'fantasia' | 'giro' | 'producto' | 'cliente' | 'telefono';
   label: string;
   minWidth?: number;
   align?: 'right';
   format?: (value: number) => string;
}

const columns: readonly Column[] = [
   { id: 'rut', label: 'Rut', minWidth: 100 },
   { id: 'razonSocial', label: 'Rut', minWidth: 100 },
   { id: 'fantasia', label: 'Fantasia', minWidth: 100 },
   { id: 'giro', label: 'Giro', minWidth: 100 },
   { id: 'producto', label: 'Producto', minWidth: 100 },
   { id: 'cliente', label: 'Cliente', minWidth: 100 },
   { id: 'telefono', label: 'Telefono', minWidth: 100 }
];
interface Data {
   rut: string;
   razonSocial: string;
   fantasia: string;
   giro: string;
   producto: string;
   cliente: string;
   telefono: string;
}

function createDataProvider(
   rut: string,
   razonSocial: string,
   fantasia: string,
   giro: string,
   producto: string,
   cliente: string,
   telefono: string,
): Data {
   return { rut, razonSocial, fantasia, giro, producto, cliente, telefono };
}
const rowsDataProvider = [
   createDataProvider('111111-K', 'Razón Social', 'Codelgo', 'Personas', 'Si', 'Si', '998754210'),
   createDataProvider('817252-K', 'Soluciones Operaticas F', 'SOFNET', 'Giro prueba', 'Si', 'Si', '87-1282760'),
   createDataProvider('22222222-1', 'Otra razón Social', 'Prueba', 'Diseño', 'Si', 'Si', '87525892'),
   createDataProvider('89000000-K', 'Otro razón más', 'Fantasia', 'Aduana', 'Si', 'Si', '91111112'),
   createDataProvider('89000000-K', 'Otro razón más', 'Fantasia', 'Aduana', 'Si', 'Si', '91111112'),
   createDataProvider('111111-K', 'Razón Social', 'Codelgo', 'Personas', 'Si', 'Si', '998754210'),
   createDataProvider('817252-K', 'Soluciones Operaticas F', 'SOFNET', 'Giro prueba', 'Si', 'Si', '87-1282760'),
   createDataProvider('22222222-1', 'Otra razón Social', 'Prueba', 'Diseño', 'Si', 'Si', '87525892')
]


export const GcProvider: React.FC<Props> = (props: Props): JSX.Element => {

   const [activeStep, setActiveStep] = useState(0);
   const [skipped, setSkipped] = useState(new Set());
   const [error, setError] = useState(null);
   const [openAccount, setOpenAccount] = useState(false);
   const [openEnterprise, setOpenEnterprise] = useState(false);
   
   const [value, setValue] = useState<Date | null>(
      new Date('2018-01-01T00:00:00.000Z'),
   );
   const [page, setPage] = useState(0);
   const [rowsPerPage, setRowsPerPage] = useState(10);

   const handleOpenAccount = () => setOpenAccount(true);
   const handleCloseAccount = () => setOpenAccount(false);

   const handleOpenEnterprise = () => setOpenEnterprise(true);
   const handleCloseEnterprise = () => setOpenEnterprise(false);

   const handleChangePage = (event: unknown, newPage: number) => {
      setPage(newPage);
   };

   const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
      setRowsPerPage(+event.target.value);
      setPage(0);
   };
   // valores que van en los inputs de cada pestaña del stepper
   const [valueGeneralInformation, setvalueGeneralInformation] = useState({
      codigo: '',
      razonSocial: '',
      giro: '',
      observacion: '',
      email: '',
      web: '',
      cliente: '',
      proveedor: '',
      cesionario: '',
      fantasia: '',
      telefono: '',
      fax: '',
      activo: '',

   });

   const [valueInventario, setvalueInventario] = useState({
      unidadMedida: '',
      stockMinimo: '',
      stockMaximo: '',
      UbicacionFisica: '',
   });

   const [valueInformation, setvalueInformation] = useState({
      situacion_inicial: '',
      fecha_compra: '',
      valor_compra: '',
      numero_factura: '',
      orden_compra: '',
      proveedor: '',
      vida_tributaria: '',
      vida_financiera: '',
      inicio_valorizacion: '',
      inicio_depreciacion: '',
      descripcion: ''
   });

   const [data, setData] = useState('');
   const [open, setOpen] = useState(false);
   const handleOpen = () => setOpen(true);
   const handleClose = () => setOpen(false);
   const [select, setSelect] = useState('');
   const inputRefs = useRef<Array<InputRef | null>>([]);

   const handleChange = (event: any) => {
      setData(event.target.value as string);
   };
   const style = {
      position: 'absolute' as 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 720,
      bgcolor: 'background.paper',
      // border: '2px solid #000',
      boxShadow: 24,
      p: 2,
      borderRadius: '20px'
   };
   //  Títulos y estilo a columnas de la tabla
   interface Column {
      id: 'Descripcion' | 'Fecha Ingreso' | 'Fecha Compra' | 'Concepto';
      label: string;
      minWidth?: number;
      align?: 'right';
      format?: (value: number) => string;
   }
   // Valores de la tabla 
   useEffect(() => {
      if (props.entity !== undefined) {
         setvalueGeneralInformation(props.entity);
         setvalueInventario(props.entity);
         setvalueInformation(props.entity);
      }
   }, []);

   const isStepSkipped = (step) => {
      return skipped.has(step);
   };

   const handleNext = () => {
      let newSkipped = skipped;
      if (isStepSkipped(activeStep)) {
         newSkipped = new Set(newSkipped.values());
         newSkipped.delete(activeStep);
      }
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      setSkipped(newSkipped);
   };

   const handleBack = () => {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
   };


   const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
      [`&.${stepConnectorClasses.alternativeLabel}`]: {
         top: 22,
      },
      [`&.${stepConnectorClasses.active}`]: {
         [`& .${stepConnectorClasses.line}`]: {
            backgroundImage:
               'linear-gradient( 95deg,#19c1d1 0%,#1976D2 50%,#1996d1 100%)',
         },
      },
      [`&.${stepConnectorClasses.completed}`]: {
         [`& .${stepConnectorClasses.line}`]: {
            backgroundImage:
               'linear-gradient( 95deg,#19c1d1 0%,#1976D2 50%,#1996d1 100%)',
         },
      },
      [`& .${stepConnectorClasses.line}`]: {
         height: 3,
         border: 0,
         backgroundColor:
            theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
         borderRadius: 1,
      },
   }));

   const ColorlibStepIconRoot = styled('div')<{
      ownerState: { completed?: boolean; active?: boolean };
   }>(({ theme, ownerState }) => ({
      backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
      zIndex: 1,
      color: '#fff',
      width: 50,
      height: 50,
      display: 'flex',
      borderRadius: '50%',
      justifyContent: 'center',
      alignItems: 'center',
      ...(ownerState.active && {
         backgroundImage:
            'linear-gradient( 136deg, #1976D2 0%, #1996d1 50%, #19c1d1 100%)',
         boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
      }),
      ...(ownerState.completed && {
         backgroundImage:
            'linear-gradient( 136deg, #1976D2 0%, #1996d1 50%, #19c1d1 100%)',
      }),
   }));


   function ColorlibStepIcon(props: StepIconProps) {
      const { active, completed, className } = props;

      const icons: { [index: string]: React.ReactElement } = {
         1: <AssignmentIcon />,
         2: <EditLocationAltIcon />,
         3: <InfoIcon />
      };

      return (
         <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
            {icons[String(props.icon)]}
         </ColorlibStepIconRoot>
      );
   }

   const mostrarFormulario = () => {
      if (activeStep === 0) {
         return (
            <FormGeneralInformation
               handleNext={handleNext}
               valueGeneralInformation={valueGeneralInformation}
               setvalueGeneralInformation={setvalueGeneralInformation}
            />
         )
      }
      else if (activeStep === 1) {
         return (
            <FormMainDirection
               handleNext={handleNext}
               valueInventario={valueInventario}
               setvalueInventario={setvalueInventario}
            />
         )
      }
      else if (activeStep === 2) {
         return (
            <FormInformation
               handleNext={handleNext}
               valueInformation={valueInformation}
               setvalueInformation={setvalueInformation}
            />
         )
      }
   }
   return (
      <Protected>
         <Container maxWidth='xl'>
            <Typography variant="h6" gutterBottom mb={3} className="tittle">
               Mantenedor de Proveedores
            </Typography>
            <Grid container flexDirection='row' spacing={2}>
               <Grid container direction="row" justifyContent="center" alignItems="center">
                  <Grid item xs={12}>
                     <Box>
                        <Box sx={{ mb: 2 }}>
                           <Stepper activeStep={activeStep} alternativeLabel connector={<ColorlibConnector />}>
                              {steps.map((label, index) => {
                                 return (
                                    <Step key={index}>
                                       <StepLabel StepIconComponent={ColorlibStepIcon} error={error === `Usuario${index}noencontrado` ? true : false}>{label.name}</StepLabel>
                                    </Step>
                                 );
                              })}
                           </Stepper>
                        </Box>
                        {activeStep === steps.length ? (
                           <div>AGREGADO</div>
                           //VALIDAR QUE EL ENVIO DE DATOS
                           // history.push(ROUTE_ACCOUNT)
                        ) : (
                           mostrarFormulario()
                        )}
                     </Box>
                  </Grid>
               </Grid>
            </Grid>

            <div className='bg-tittle'>
               <Typography
                  mt={3}
                  variant="h6"
                  align='center'
                  className='tittle-text'
               >
                  Listado Proveedores Ingresados
               </Typography>
            </div>
         </Container>

         <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer component={Paper}>
               <Table aria-label="simple table">
                  <TableHead>
                     <TableRow>
                        <TableCell >Rut</TableCell>
                        <TableCell >Razón Social</TableCell>
                        <TableCell >Fantasía</TableCell>
                        <TableCell >Giro</TableCell>
                        <TableCell >Producto</TableCell>
                        <TableCell >Cliente</TableCell>
                        <TableCell >Teléfono</TableCell>
                        <TableCell >Opciones</TableCell>
                        <TableCell >Cuenta Corriente</TableCell>
                     </TableRow>
                  </TableHead>
                  <TableBody>
                     {rowsDataProvider.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                        return (
                           <TableRow hover role="checkbox" tabIndex={-1} key={row.rut}>
                              {columns.map((column) => {
                                 const value = row[column.id];
                                 return (
                                    <TableCell key={column.id} align={column.align}>
                                       {column.format && typeof value === 'number'
                                          ? column.format(value)
                                          : value}
                                    </TableCell>
                                 );
                              })}
                              <TableCell>
                                 <IconButton
                                    aria-label="Editar"
                                    onClick={() => handleOpenEnterprise()}
                                    className='btn_delete'
                                 // disabled={loading}
                                 >
                                    <BusinessIcon />                                    
                                 </IconButton>

                                 <IconButton
                                    aria-label="Ver Ficha"
                                    // onClick={() => handleDelete(row.id)}
                                    className='btn_delete'
                                 // disabled={loading}
                                 >
                                    <Assignment />
                                 </IconButton>
                              </TableCell>
                              <TableCell >
                                 <IconButton
                                    aria-label="Ingresar Proveedor"
                                    onClick={() => handleOpenAccount()}
                                    className='btn_delete'
                                 // disabled={loading}
                                 >
                                    <AddCircleIcon className="btn_add_provider" />
                                 </IconButton>
                              </TableCell>

                           </TableRow>
                        );
                     })}
                  </TableBody>
               </Table>
            </TableContainer>
            <TablePagination
               rowsPerPageOptions={[10, 25, 100]}
               component="div"
               count={rowsDataProvider.length}
               rowsPerPage={rowsPerPage}
               page={page}
               onPageChange={handleChangePage}
               onRowsPerPageChange={handleChangeRowsPerPage}
            />
         </Paper>
         <Modal
            open={openAccount}
            onClose={handleCloseAccount}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
         >
            <Box sx={style} >
               <DataModalAccount entity={undefined} />
            </Box>
         </Modal>
         <Modal
            open={openEnterprise}
            onClose={handleCloseEnterprise}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
         >
            <Box sx={style} >
               <DataModalEnterprise entity={undefined} />
            </Box>
         </Modal>

      </Protected>

   );
};